import React, { useState } from 'react';
import {
  Button, Container, Grid, Paper, TextField, Typography, Rating,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import securedInstance from '../../../../api/securedInstance';
import { toast } from 'react-toastify';

const UploadTestimonialForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    candidate_name: '',
    job_role: '',
    feedback: '',
    rating: 5,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.candidate_name.trim() || !formData.feedback.trim()) {
      toast.error('Name and feedback are required');
      return;
    }
    try {
      await securedInstance.post('/api/testimonials', {
        candidate_name: formData.candidate_name,
        job_role: formData.job_role,
        feedback: formData.feedback,
        rating: formData.rating,
        student_id: null,
        program_id: null,
      });
      toast.success('Testimonial added successfully');
      navigate('/auth/allTestimonials');
    } catch (err) {
      toast.error('Failed to add testimonial');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ display: 'flex', mt: 4 }}>
      <Paper elevation={2} sx={{ padding: '28px', width: '100%' }}>
        <form onSubmit={handleSubmit}>
          <Typography variant="h6" gutterBottom>Add New Testimonial</Typography>
          <Button onClick={() => navigate(-1)} sx={{ mb: 2 }}>Back</Button>

          <Grid container spacing={2} sx={{ border: '1px solid rgba(0,0,0,0.125)', padding: '20px' }}>
            <Grid item xs={12}>
              <TextField
                label="Student Name" name="candidate_name" fullWidth required
                value={formData.candidate_name} onChange={handleChange}
                placeholder="e.g. Rohan Kumar"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Role / Program" name="job_role" fullWidth
                value={formData.job_role} onChange={handleChange}
                placeholder="e.g. Developer Program"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Feedback" name="feedback" fullWidth required multiline rows={4}
                value={formData.feedback} onChange={handleChange}
                placeholder="Enter the student's testimonial…"
              />
            </Grid>

            <Grid item xs={12}>
              <Typography component="legend" sx={{ fontSize: 14, mb: 0.5, color: 'text.secondary' }}>
                Rating
              </Typography>
              <Rating
                value={formData.rating}
                onChange={(_, val) => setFormData({ ...formData, rating: val })}
                size="large"
              />
            </Grid>

            <Grid item xs={12}>
              <Button
                type="submit" variant="contained" fullWidth
                style={{ backgroundColor: '#3251A3' }}
              >
                Submit Testimonial
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};

export default UploadTestimonialForm;
